 <opac-tab-group #tabGroup *ngIf="ranking?.center">
  <opac-tab (select)="changeSlot(RankingScope.PLATFORM)" [active]="rankingScope === rankingScopeValues.PLATFORM" panel="platform">
    {{'general.platform' | translate}}
  </opac-tab>
  <opac-tab (select)="changeSlot(RankingScope.CENTER)" [active]="rankingScope === rankingScopeValues.CENTER" panel="center">
    {{centerLabel() | translate}}
  </opac-tab>
  <opac-tab-panel name="platform">
    <ng-container *ngTemplateOutlet="tabContent"></ng-container>
  </opac-tab-panel>
  <opac-tab-panel name="center">
    <ng-container *ngTemplateOutlet="tabContent"></ng-container>
  </opac-tab-panel>
</opac-tab-group>

<ng-template #tabContent>
  <section>
    <app-slot *ngFor="let slot of slots()" [slot]="slot" [userId]="userService.getUserId()"></app-slot>
  </section>
</ng-template>

<section *ngIf="!ranking?.center">
  <app-slot *ngFor="let slot of platformSlots()" [slot]="slot" [userId]="userService.getUserId()"></app-slot>
</section>
